/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsWifi: {
  name: 'wifi';
  data: string;
} = {
  name: 'wifi',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.808 9.808c5.077-5.077 13.308-5.077 18.384 0a1 1 0 0 0 1.415-1.415c-5.858-5.857-15.356-5.857-21.214 0a1 1 0 1 0 1.415 1.415Zm14.849 3.535a8 8 0 0 0-11.314 0A1 1 0 1 1 4.93 11.93c3.905-3.905 10.237-3.905 14.142 0a1 1 0 0 1-1.414 1.414ZM9.879 16.88a3 3 0 0 1 4.242 0 1 1 0 0 0 1.415-1.415 5 5 0 0 0-7.071 0 1 1 0 1 0 1.414 1.415ZM12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
